import { OperationFragmentFragment } from "../gql/generated/stats2.sdk";
import { TPool } from "./Pool.types";

export enum EOpTypename {
  OpSwap = "OpSwap",
  OpDepositMixed = "OpDepositMixed",
  OpDepositSingle = "OpDepositSingle",
  OpWithdraw = "OpWithdraw",
  OpUnlock = "OpUnlock",
  OpLock = "OpLock",
  OpZap = "OpZap",
  OpMigrate = "OpMigrate",
  OpUpdate = "OpUpdate",
}

export enum EOpsStatus {
  ALL = "ALL",
  CANCELED = "CANCELED",
  COMPLETED = "COMPLETED",
  PENDING = "PENDING",
  SUBMITTED = "SUBMITTED",
}

export interface IOperation extends Omit<OperationFragmentFragment, "pool"> {
  pool: TPool;
}
